export default "__VITE_ASSET__pX_XSEOB__"